var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.6C0 1.61177 1.61178 0 3.6 0H20.4C22.3882 0 24 1.61178 24 3.6V20.4C24 22.3882 22.3882 24 20.4 24H3.6C1.61177 24 0 22.3882 0 20.4V3.6Z",
    fill: "#FF9505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50878 8.74845V6.95286H8.86333V17.1H6.85895V8.74845H5.50878Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7049 15.1235V13.5923L15.2565 7.07814H17.5253V13.4253H18.7502V15.1235H17.5253V17.1H15.5766V15.1235H10.7049ZM15.7019 9.16602L12.8485 13.4253H15.7019V9.16602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge14);
export default __webpack_public_path__ + "static/media/age14.5183c922.svg";
export { ForwardRef as ReactComponent };